<template>
  <div class="ad-group-wrap">
    <div class="card-header">广告组</div>
    <div class="btn-group">
      <el-button icon="el-icon-plus" type="primary" @click="addAdGroup">新建广告组</el-button>
      <el-button icon="el-icon-plus" class="def-btn" @click="hasAdGroup">已有广告组</el-button>
    </div>
    <div class="newgroup-wrap" style="padding-top: 20px" v-show="dialogVisible">
      <ul class="modal-form">
        <el-form :model="formData" :rules="rules" ref="ruleForm">
          <li class="form-item">
            <span class="form-label" style="padding-top: 0px">广告组预算：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.budgetMode">
                <el-radio label="BUDGET_MODE_INFINITE">不限</el-radio>
                <el-radio label="BUDGET_MODE_DAY">指定预算</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item" v-show="formData.budgetMode === 'BUDGET_MODE_DAY'" style="margin-bottom: 0px">
            <span class="form-label">日预算：</span>
            <div class="form-value">
              <el-form-item prop="budget">
                <el-input style="width: 264px" placeholder="(必填) >= 300" v-model="formData.budget">
                  <template slot="append">CNY</template>
                </el-input>
              </el-form-item>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label">广告组名称：</span>
            <div class="form-value">
              <el-form-item prop="campaignName">
                <el-input style="width: 264px" placeholder="(必填)请输入广告组名称" v-model="formData.campaignName"> </el-input>
              </el-form-item>
              <ul class="name-list">
                <li
                  v-for="(item, index) of showAdList"
                  :key="index"
                  :class="['name-item', selectItem.indexOf(index) === -1 ? '' : 'cur']"
                  @click="handleSelectItem(item, index)"
                >
                  {{ item }}
                </li>
                <li class="show-more">
                  <span v-show="!showMore" @click="showMore = true">更多<i class="el-icon-arrow-down"></i></span>
                  <span v-show="showMore" @click="showMore = false">收起<i class="el-icon-arrow-up"></i></span>
                </li>
              </ul>
            </div>
          </li>
        </el-form>
      </ul>
    </div>
    <div class="table-wrap" v-show="!dialogVisible">
      <el-table :data="adGroupTable" style="width: 100%" v-loading="tableLoading">
        <el-table-column prop="campaign_name" label="广告组名称"> </el-table-column>
        <el-table-column prop="account_id" label="广告账号"> </el-table-column>
        <el-table-column label="组预算">
          <template slot-scope="scope">
            <div class="show-wrap">
              <span class="show-label">日预算：</span>
              <span class="budget-value">{{ scope.row.budgetMode === "BUDGET_MODE_INFINITE" ? "不限" : scope.row.budget }}</span>
              <el-popover v-model="scope.row.showPopover" placement="bottom" width="238" trigger="manual">
                <div class="edit-budget-wrap">
                  <span style="font-size: 14px; color: rgba(0, 0, 0, 0.65)">预算：</span>
                  <el-radio-group v-model="scope.row.edit_budgetMode">
                    <el-radio label="BUDGET_MODE_INFINITE">不限</el-radio>
                    <el-radio label="BUDGET_MODE_DAY">指定预算</el-radio>
                  </el-radio-group>
                  <el-form :rules="popoverRule" :model="scope.row" :ref="'ref' + scope.row.campaign_id">
                    <el-form-item prop="edit_budget" v-show="scope.row.edit_budgetMode === 'BUDGET_MODE_DAY'">
                      <el-input style="margin-top: 10px" v-model="scope.row.edit_budget" placeholder="请输入日预算"></el-input>
                    </el-form-item>
                  </el-form>

                  <div class="button-wrap" style="text-align: right; margin-top: 16px">
                    <el-button @click="scope.row.showPopover = false" style="height: 26px" size="mini">取消</el-button>
                    <el-button style="height: 26px" size="mini" type="primary" @click="editConfirm('ref' + scope.row.campaign_id)"
                      >确定</el-button
                    >
                  </div>
                </div>
                <template slot="reference">
                  <svg-icon iconClass="pen" className="icon" @click="setCur(scope.row)"></svg-icon>
                </template>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="deleteTableItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 已有广告组弹框 -->
    <el-dialog title="已有广告组" :visible.sync="showHasModal" width="969px" @opened="openHasModal">
      <div class="modal-body">
        <div class="transfer-wrap">
          <div class="top-list">
            <div class="list-header">广告账号：</div>
            <ul class="count-list">
              <li
                :class="['count-item', item.advertiserId === curId ? 'cur' : '']"
                v-for="(item, index) of adCount"
                :key="index"
                @click="selectCount(item.advertiserId)"
              >
                <span class="item-detial">{{ item.advertiserName }}</span>
                <span class="item-detial">ID：{{ item.advertiserId }}</span>
                <span class="item-count">{{ selectListMap[item.advertiserId] ? selectListMap[item.advertiserId].length : 0 }}</span>
              </li>
            </ul>
          </div>
          <el-transfer
            filterable
            filter-placeholder="请输入搜索"
            v-model="checkedValue"
            :data="secondList"
            :props="{ key: 'campaignId', label: 'campaignName' }"
            @change="selectAdGroup"
            :titles="['待选广告组', '已选广告组']"
          ></el-transfer>
        </div>
        <span slot="footer" class="footer-wrap">
          <el-button @click="showHasModal = false">取 消</el-button>
          <el-button type="primary" @click="confirmeSelect">确 定</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { queryCampaign, updateCampaign } from "@/api/promotion.js";
import SvgIcon from "@/components/SvgIcon.vue";
import nameTransforUtil from "./common/nameTransforUtil.js";
export default {
  components: {
    SvgIcon,
  },
  data() {
    return {
      dialogVisible: true, //是否展示新建表单
      showHasModal: false,
      selectItem: [],
      adGroupList: [
        "推广目标",
        "应用名称",
        "创建日期",
        "预算类型",
        "投放范围",
        "广告位置",
        "投放形式",
        "转化名称",
        "账户备注名",
        "首个视频名称",
        "首个图片名称",
      ],
      showMore: true,
      formData: {
        budgetMode: "BUDGET_MODE_DAY",
        budget: "",
        campaignName: "",
      },
      rules: {
        budget: [{ validator: this.checkBudget, trigger: ["blur", "change"] }],
        campaignName: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (value === "" && this.dialogVisible === true) {
                callback(new Error("广告组名称必填"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      //已有弹框相关内容****************************************************
      curId: null,
      secondList: [], //穿梭框待选
      checkedValue: [], //穿梭框已选
      dataListMap: {},
      selectListMap: {},
      adGroupTable: [],
      curEdit: {}, //当前编辑的数据
      tableLoading: false,
      popoverRule: {
        edit_budget: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (this.curEdit.edit_budgetMode === "BUDGET_MODE_INFINITE") {
                callback();
              } else if (this.curEdit.edit_budget === "") {
                callback(new Error("请输入日预算"));
              } else if (!/^[0-9]*$/.test(this.curEdit.edit_budget) || Number(this.curEdit.edit_budget) < 300) {
                callback(new Error("请输入不小于300的数字"));
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },
  methods: {
    addAdGroup() {
      if (!this.dialogVisible) {
        this.$store.commit("set_draft_campaign", null);
      }
      this.dialogVisible = true;
    },
    checkBudget(rule, value, callback) {
      if (this.dialogVisible === false || this.formData.budgetMode === "BUDGET_MODE_INFINITE") {
        callback();
      } else if (value === "") {
        callback(new Error("请输入日预算"));
      } else if (!/^[0-9]*$/.test(value) || Number(value) < 300) {
        callback(new Error("请输入不小于300的数字"));
      } else {
        callback();
      }
    },
    handleSelectItem(item, itemIndex) {
      let index = this.selectItem.findIndex((item) => item === itemIndex);
      if (index === -1) {
        this.selectItem.push(itemIndex);
        this.formData.campaignName += "{" + item + "}";
      } else {
        this.selectItem.splice(index, 1);
        this.formData.campaignName = this.formData.campaignName.replace("{" + item + "}", "");
      }
    },
    deleteTableItem(item) {
      let copyList = JSON.parse(JSON.stringify(this.adGroupTable));
      let canDelete = copyList.find((listitem) => {
        return listitem.account_id === item.account_id && listitem.campaign_id !== item.campaign_id;
      });
      if (canDelete) {
        this.$confirm("确定删除该广告组?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let delIndex = this.adGroupTable.findIndex((tableItem) => tableItem.campaign_id === item.campaign_id);
            if (delIndex !== -1) {
              this.adGroupTable.splice(delIndex, 1);
              this.saveInstore();
            }
          })
          .catch(() => {});
      } else {
        this.$message({
          message: "该账户下至少需要保留一个广告组",
          type: "warning",
        });
      }
    },
    //选择已有相关*********************************************************
    hasAdGroup() {
      if (this.adCount.length === 0) {
        this.$alert("请选择广告账号后再操作", "提示", {
          confirmButtonText: "确定",
        });
      } else {
        this.showHasModal = true;
      }
    },
    //选择账号
    selectCount(advertiserId) {
      this.curId = advertiserId;
      this.secondList = this.dataListMap[this.curId];
      this.checkedValue = this.selectListMap[this.curId] || [];
    },
    //选择广告组
    selectAdGroup() {
      this.selectListMap[this.curId] = this.checkedValue;
    },
    openHasModal() {
      let adList = this.adCount.map((item) => item.advertiserId);
      this.curId = adList[0];
      queryCampaign({
        advertiserId: adList.join(),
      }).then((res) => {
        if (res.code === "0000") {
          this.dataListMap = res.map;
          this.selectCount(this.curId);
        }
      });
    },
    checkSelectData() {
      let flag = true;
      let that = this;
      that.adCount.forEach((item) => {
        if (!that.selectListMap[item.advertiserId] || that.selectListMap[item.advertiserId].length === 0) {
          that.$message({
            message: item.advertiserName + " " + "账号下未选择广告组",
            type: "warning",
          });
          flag = false;
        }
      });
      return flag;
    },
    //选择已有确定
    confirmeSelect() {
      if (this.checkSelectData()) {
        let adGroup = [];
        for (let [id, mapArr] of Object.entries(this.dataListMap)) {
          mapArr.forEach((item) => {
            if (this.selectListMap[id].includes(item.campaignId)) {
              adGroup.push(item);
            }
          });
        }
        this.showHasModal = false;
        this.dialogVisible = false;
        //保存到store
        let copyList = JSON.parse(JSON.stringify(adGroup)).map((item) => {
          return {
            campaign_name: item.campaignName,
            campaign_id: item.campaignId,
            account_id: item.advertiserId,
            budget: item.budget || 300,
            budgetMode: item.budgetMode,
            modifyTimeStamp: item.modifyTimeStamp,
          };
        });
        this.$store.commit("set_draft_campaign", {
          online_campaign: copyList,
        });
      }
    },
    saveInstore() {
      let storeData = {
        online_campaign: this.adGroupTable.map((item) => {
          return {
            campaign_name: item.campaign_name,
            campaign_id: item.campaign_id,
            account_id: item.account_id,
            budget: item.budget,
            budgetMode: item.budgetMode,
            modifyTimeStamp: item.modifyTimeStamp,
          };
        }),
      };
      this.$store.commit("set_draft_campaign", storeData);
    },
    checkData() {
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            if (this.dialogVisible) {
              //保存新建的广告组表单数据到store
              let parmas = {
                account_id: this.adCount.map((item) => item.advertiserId),
                budget_mode: this.formData.budgetMode,
                name_rule: nameTransforUtil.showDataToApi(this.formData.campaignName),
                landing_type: "APP",
              };
              if (this.formData.budgetMode === "BUDGET_MODE_DAY") {
                parmas.budget = this.formData.budget;
              }
              //保存到store
              this.$store.commit("set_draft_campaign", parmas);
            } else {
              //添加广告账户数据到已有广告组数据中
              let online_campaign = JSON.parse(JSON.stringify(this.draft_campaign.online_campaign));
              this.$store.commit("set_draft_campaign", {
                online_campaign: online_campaign,
                account_id: this.adCount.map((item) => item.advertiserId),
              });
            }
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    editConfirm(refName) {
      this.$refs[refName].validate((valid) => {
        if (valid) {
          if (this.curEdit.budgetMode === this.curEdit.edit_budgetMode && this.curEdit.budget === this.curEdit.edit_budget) {
            this.curEdit.showPopover = false;
            return;
          }
          this.curEdit.showPopover = false;
          this.tableLoading = true;
          updateCampaign({
            account_id: this.curEdit.account_id,
            budget: this.curEdit.edit_budget,
            budgetMode: this.curEdit.edit_budgetMode,
            campaign_id: this.curEdit.campaign_id,
            campaign_name: this.curEdit.campaign_name,
            modifyTimeStamp: this.curEdit.modifyTimeStamp,
          }).then((res) => {
            this.tableLoading = false;
            if (res.code === "0000") {
              this.curEdit.budgetMode = this.curEdit.edit_budgetMode;
              this.curEdit.budget = this.curEdit.edit_budget;
              this.saveInstore();
            }
          });
        }
      });
    },
    setCur(data) {
      this.curEdit = data;
      this.curEdit.showPopover = true;
    },
  },
  computed: {
    showAdList() {
      if (!this.showMore) {
        return this.adGroupList.slice(0, 6);
      }
      return this.adGroupList;
    },
    ...mapState({
      adCount: (state) => state.Promotion.adCount,
      draft_campaign: (state) => state.Promotion.draft_campaign,
    }),
  },
  watch: {
    draft_campaign(value) {
      if (value) {
        let storeList = JSON.parse(JSON.stringify(value));
        if (storeList.online_campaign) {
          //选择已有格式
          this.dialogVisible = false;
          this.adGroupTable = storeList.online_campaign.map((item) => {
            //修改使用
            item.edit_budget = item.budget || 300;
            item.edit_budgetMode = item.budgetMode;
            //是否显示弹窗
            item.showPopover = false;
            return item;
          });
        } else {
          this.dialogVisible = true;
          this.formData.budgetMode = value.budget_mode;
          if (value.budget_mode === "BUDGET_MODE_DAY") {
            this.formData.budget = value.budget;
          } else {
            this.formData.budget = "";
          }
          this.formData.campaignName = nameTransforUtil.apiDatatoShow(value.name_rule);
          this.selectItem = [];
          this.adGroupList.map((item, index) => {
            if (this.formData.campaignName.includes(`{${item}}`)) {
              this.selectItem.push(index);
            }
          });
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.ad-group-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
  }
  .btn-group {
    margin-top: 16px;
    .def-btn {
      color: rgba(24, 144, 255, 1);
      border: 1px solid rgba(24, 144, 255, 1);
    }
  }
  .table-wrap {
    margin-top: 16px;
    .show-wrap {
      font-size: 14px;
      .show-label {
        color: rgba(0, 0, 0, 0.65);
      }
      .budget-value {
        color: rgba(0, 0, 0, 0.85);
      }
      .icon {
        cursor: pointer;
        margin-left: 8px;
      }
    }
  }
  .newgroup-wrap,
  .modal-body {
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 16px;
        /deep/.el-form-item__error {
          top: 11px;
          left: 280px;
        }
        /deep/ .el-form-item {
          margin-bottom: 6px;
        }
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 90px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          padding-top: 6px;
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          .list-wrap {
            max-height: 120px;
            overflow: auto;
            .adCountItem {
              height: 22px;
              line-height: 22px;
              border-radius: 2px;
              display: inline-block;
              padding: 0 8px;
              margin: 0 8px 8px 0;
              background: rgba(233, 233, 233, 0.6);
              color: rgba(0, 0, 0, 0.65);
              .close-btn {
                display: inline-block;
                margin-left: 6px;
                font-size: 18px;
                cursor: pointer;
                position: relative;
                top: 1px;
              }
            }
          }
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(24, 144, 255, 1);
          }
          /deep/ .el-input-group__append,
          /deep/ .el-input-group__prepend {
            background-color: #fff;
            color: rgba(0, 0, 0, 0.85);
            padding: 0 10px;
          }
          .name-list {
            padding: 12px 0px 0px 0px;
            margin: 0px;
            list-style: none;
            display: flex;
            flex-wrap: wrap;
            .name-item {
              border-radius: 2px;
              border: 1px solid transparent;
              box-sizing: border-box;
              background: rgba(233, 233, 233, 0.6);
              color: rgba(0, 0, 0, 0.85);
              font-size: 12px;
              padding: 2px 6px;
              margin: 0 8px 8px 0px;
              cursor: pointer;
              &.cur {
                border: 1px solid rgba(24, 144, 255, 1);
                background: rgba(225, 240, 255, 1);
                color: rgba(24, 144, 255, 1);
              }
            }
            .show-more {
              color: rgba(24, 144, 255, 1);
              font-size: 13px;
              cursor: pointer;
              margin-left: 20px;
              line-height: 24px;
              i {
                margin-left: 4px;
              }
            }
          }
        }
      }
    }
    .footer-wrap {
      text-align: right;
      display: block;
      padding-bottom: 24px;
    }
    .transfer-wrap {
      display: flex;
      margin-bottom: 24px;
      .top-list {
        width: 250px;
        border: 1px solid #ebeef5;
        .list-header {
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          padding: 10px 0px 10px 12px;
          border-bottom: 1px solid #ebeef5;
        }
        .count-list {
          overflow: auto;
          height: 316px;
          padding: 0px;
          margin: 0px;
          list-style: none;
          .count-item {
            cursor: pointer;
            padding: 6px 10px;
            position: relative;
            .item-detial {
              display: block;
              font-size: 12px;
              color: #666;
            }
            &.cur {
              background-color: rgba(230, 247, 255, 1);
            }
          }
          .item-count {
            position: absolute;
            right: 10px;
            top: 11px;
            width: 17px;
            height: 17px;
            border-radius: 3px;
            background: rgba(24, 144, 255, 1);
            color: rgba(255, 255, 255, 1);
            font-size: 14px;
            text-align: center;
            line-height: 17px;
          }
        }
      }
      /deep/ .el-checkbox {
        margin-right: 0px;
      }
    }
  }
}
</style>
